<template>
  <div v-if="Object.values(casamento).length > 0"
       class="content--sinoreg Resumo ">
    <div>
      <div v-if="casamento.registro.cod_motivo_alt == 30"
           class="col p-2 Resumo--bg-danger">
        <b>Registro bloqueado por Determinação Judicial</b>
      </div>
    </div>
    <header-blue class="headerBlueResumo">
      <h4 class="resumo-show_title pl-2">
        <b-row>
          <div class="pr-0 d-flex align-items-center registro_title">
            <icon-svg icon="engagement"
                      class="icon--md icons--white typeIcon ml-3 mr-2 mt-2" />
            Casamento
          </div>
          <div class="registro_dados">
            <b-row>
              <b-col cols="9"
                     class="m-0 p-0">
                <b-row>
                  <HeaderBoxCasamento v-if="casamento.registro_id"
                                      info-title="Cônjuge 1"
                                      :info-name="casamento.registro.pessoas[0].nome_antigo"
                                      :info-cpf="casamento.registro.pessoas[0].cpf | cpf" />
                </b-row>
                <b-row>
                  <HeaderBoxCasamento v-if="casamento.registro_id"
                                      info-title="Cônjuge 2"
                                      :info-name="casamento.registro.pessoas[1].nome_antigo"
                                      :info-cpf="casamento.registro.pessoas[1].cpf | cpf" />
                </b-row>
              </b-col>
              <b-col cols="3"
                     class="d-flex justify-content-end pl-5">
                <b-row>
                  <NavegacaoRegistros :prop-registro-id="casamento.registro_id"
                                      :prop-tipo-registro="casamento.registro.tipo_registro" />
                </b-row>
                <div />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="9"
                     class="m-0 p-0">
                <b-row>
                  <HeaderBoxResume v-if="casamento.registro_id"
                                   :info="casamento.registro.data_ocorrido | date"
                                   text="Data do ocorrido" />
                  <HeaderBoxResume v-if="casamento.registro_id"
                                   :info="casamento.registro.data_registro | date"
                                   text="Data de registro" />
                  <HeaderBoxResume v-if="casamento.registro_id"
                                   class="matricula_id"
                                   :info="casamento.registro.matricula | maskMatricula"
                                   text="Matrícula" />
                </b-row>
              </b-col>
              <b-col cols="3">
                <button class="row btn btn-sm btn-outline-primary btn-block btn-acessar-reg-hab pt-2 pb-2"
                        type="button"
                        :disabled="(!casamento.habilitacao || !casamento.habilitacao.habilitacao_casamento_id)"
                        @click="acessarEHabilitacao()">
                  Acessar e-habilitação
                </button>
              </b-col>
            </b-row>
          </div>
        </b-row>
      </h4>
    </header-blue>
    <b-tabs v-model="tabIndex"
            content-class=""
            class="Resumo-border"
            align="left"
            active-nav-item-class="Resumo--tab-active">
      <b-tab :active="tabIndex == 0">
        <template v-slot:title>
          <icon-svg icon="engagement"
                    class="icon--sm" />
          Resumo
        </template>

        <ResumoCasamentoDetalhes v-if="tabIndex == 0"
                                 :prop-casamento="casamento"
                                 :prop-pedido-pendente="propPedidoPendente"
                                 :prop-numero-pedido-possue-certidao-eletronica="numeroPedidoPossueCertidaoEletronica"
                                 @reload="init()" 
                                 @fecharModalAvisoNumeroPedidoPossuiCertidaoEletronica="onFecharModal" />
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <icon-svg icon="image"
                    class="icon--sm" />
          Imagens
        </template>

        <ResumoImagens v-if="casamento.registro_id && tabIndex == 1"
                       tipo-registro="C"
                       :allow-add="true"
                       :prop-imagens="casamento.registro.documentos"
                       :registro-id="casamento.registro_id"
                       @updateData="updateData" />
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <icon-svg icon="note"
                    class="icon--sm" />
          Averbações/Anotações
        </template>

        <AverbacaoEProcedimento v-if="casamento.registro && tabIndex === 2"
                                :prop-tipo-registro="casamento.registro.tipo_registro"
                                :prop-registro-id="casamento.registro_id"
                                :prop-registro="casamento.registro"
                                :prop-regime-bens="casamento.regime_bens"
                                :prop-transporte="casamento.registro.transporte"
                                @onTabImpressao="tabImpressao"
                                @imprimir="imprimir" />
      </b-tab>
      <b-tab :active="gerarOS || !!propIdOs">
        <template v-slot:title>
          <icon-svg icon="dolar"
                    class="icon--sm" />
          Ordens de Serviços
        </template>
        <ResumoOrdensServicos v-if="casamento.registro_id && tabIndex == 3"
                              :prop-registro-id="casamento.registro_id"
                              :prop-tipo="'casamento'"
                              :prop-registro="casamento.registro"
                              :prop-data="casamento"
                              :prop-solicitante="solicitante"
                              :prop-novo="compNewOS"
                              :prop-os="propIdOs"
                              :prop-segunda-via="compOsSegundaVia"
                              :prop-pedido-pendente="propPedidoPendente"
                              :prop-numero-pedido-possue-ordem-servico="numeroPedidoPossueOrdemServico"
                              @onUpdateOrdemServico="updateOrdemServico"
                              @imprimir="imprimir"
                              @resetSegundaVia="segundaVia = false" />
      </b-tab>

      <b-tab :disabled="casamento.registro.cod_motivo_alt == 30">
        <template v-slot:title>
          <icon-svg icon="print"
                    class="icon--sm" />
          Impressão
        </template>


        <Impressao v-if="tabIndex == 4"
                   :data="casamento"
                   :ordem-servico="ordem_servico"
                   :prop-imprimir-os="os"
                   :prop-pedido-pendente="propPedidoPendente"
                   tipo="casamento" />
      </b-tab>

      <b-tab :active="tabIndex === 5">
        <template v-slot:title>
          <icon-svg icon="copy"
                    class="icon--sm" />
          2ª via
        </template>
        <SegundaViaCasamento v-if="tabIndex === 5 && casamento.registro"
                             :prop-casamento="casamento"
                             @changeRegistro="changeRegistro"
                             @goOS="goOS" />
      </b-tab>

      <b-tab :active="tabIndex === 6">
        <template v-slot:title>
          <icon-svg icon="qrcode"
                    class="icon--sm" />
          Selos
        </template>

        <template v-slot:default>
          <ResumoSelos v-if="tabIndex === 6"
                       :prop-registro-id="casamento.registro_id"
                       :prop-cpf-registrado="casamento.registro.pessoas[0].cpf || casamento.registro.pessoas[1].cpf"
                       :prop-nome-registrado="casamento.registro.pessoas[0].nome_antigo || casamento.registro.pessoas[1].nome_antigo"
                       :prop-habilitacao="casamento.habilitacao"
                       :prop-open-window-editar-vinculacao="propOpenWindowEditarVinculacao" />
        </template>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  /* componentes */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import HeaderBoxResume from "@/components/SofiaRei/Busca/HeaderBoxResume"
  import HeaderBoxCasamento from "@/components/SofiaRei/Busca/HeaderBoxCasamento"
  import ResumoCasamentoDetalhes from "@/components/SofiaRei/Casamento/ResumoCasamentoDetalhes"
  import ResumoImagens from "@/components/SofiaRei/Resumo/ResumoImagens"
  import ResumoOrdensServicos from "@/components/SofiaRei/Resumo/ResumoOrdensServicos"
  import Impressao from "@/components/SofiaRei/Resumo/Impressao/Impressao"
  import NavegacaoRegistros from '@/components/SofiaRei/NavegacaoRegistros'
  import ResumoSelos from '@/components/SofiaRei/Resumo/Selo/ResumoSelos'
  import SegundaViaCasamento from "@/components/SofiaRei/Casamento/SegundaVia/SegundaViaCasamento"
  import AverbacaoEProcedimento from '@/components/SofiaRei/Casamento/AverbacaoEProcedimento.vue'

  /* services */
  import CasamentoService from "@/services/Registros/Casamento"

  /* utils */
  import { cumprirPedidos } from '@/utils/cumprirPedidos'

  import { mapGetters } from "vuex"
  import moment from 'moment'

  export default {
    name: "ResumoCasamento",
    components: {
      HeaderBlue,
      HeaderBoxResume,
      HeaderBoxCasamento,
      ResumoCasamentoDetalhes,
      ResumoOrdensServicos,
      Impressao,
      ResumoImagens,
      NavegacaoRegistros,
      ResumoSelos,
      SegundaViaCasamento,
      AverbacaoEProcedimento
    },
    props: {
      propPedidoPendente: {type: Object, default: () => {}},
      gerarOS: { type: Boolean, default: false },
      propCasamento: {type: Object, default: () => ({})},
      propMostrarSelo: { type: Boolean, default: () => false },
      propOpenWindowEditarVinculacao: { type: Object, default: () => null },
      propIdOs: { type: Number, default: null},
      legado: { type: Boolean, default: false}
    },
    data () {
      return {
        tabIndex: 0,
        casamento_id: this.$route.params.id,
        casamento: {},
        solicitante: {},
        ordem_servico: [],
        os: {},
        newOs: false,
        segundaVia: false,
        ordemServicoCompare: [],
        pedidoPendente: {},
        gerenciarExibicaoRecibo: false,
        numeroPedidoPossueOrdemServico: false,
        numeroPedidoPossueCertidaoEletronica: false,
        respostaModalNumeroPedidoPossuiCertidaoEletronica: ''
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        modalImpressaoEstaFechado: 'impressaoReciboOS/getModalImpressaoEstaFechado',
        recusarImpressaoReciboDeServico: 'impressaoReciboOS/getRecusarImpressaoReciboDeServico'
      }),
      compNewOS () {
        return this.newOs 
      },
      compOsSegundaVia () {
        return this.segundaVia && (this.ordemServicoCompare.length === this.ordem_servico.length)
      }
    },
    watch: {
      propCasamento () {
        if (Object.values(this.propCasamento).length) {
          this.changeRegistro(this.propCasamento)
          return
        }
      },
      modalImpressaoEstaFechado (novoValor) {
        this.gerenciarExibicaoRecibo = novoValor
      },
      gerenciarExibicaoRecibo (novoValor) {
        novoValor && this.tabImpressao()
      },
      recusarImpressaoReciboDeServico () {
        this.tabImpressao()
      }
    },
    async created () {
      this.$watch(
        () => [this.tabIndex, this.numeroPedidoPossueOrdemServico],
        ([novoTab, novoNumero], [velhoTab, velhoNumero]) => {
          if (velhoTab !== 0 && novoTab !== 3 && velhoNumero !== false && novoNumero == true) this.numeroPedidoPossueOrdemServico = false
        },
        { immediate: false, deep: false }
      )

      await this.init()


      if (this.propMostrarSelo) {
        this.tabIndex = 6
      }

      if (this.legado) {
        this.tabIndex = 5
      }
    },
    beforeMount () {
      if (this.$route.query && this.$route.query.mostrarSelos) {
        const params = {
          propMostrarSelo: true
        }

        if (this.$route.query.seloVinculador && this.$route.query.dataVinculacao) {
          params.propOpenWindowEditarVinculacao = {
            numSeloVinculador: this.$route.query.seloVinculador,
            dataVinculacao: moment(this.$route.query.dataVinculacao, 'DD-MM-YYYY-HH-mm-ss').format('YYYY-MM-DD HH:mm:ss')
          }
        }

        /**
         * Precisamos fazer um push na mesma rota, para passar as props, e para limpar a query do route, pois é imutável.
         * Se não fizermos isso, ao atualizar a página, sempre vai direcionar lá para tab de selos novamente, e queremos que o usuário navegue livremente.
         */
        this.$router.push({ name: 'resumo_casamento', params: { id: this.$route.params.id, ...params } })
      }
    },
    methods: {
      async init () {
        try {
          loader({ text: "Carregando...", active: true })

          this.casamento = await CasamentoService.getCasamento(this.$route.params.id)

          this.newOs = this.gerarOS


          if (this.casamento.registro && this.casamento.registro.documentosGED) {
            // mostrar apenas permitidos
            const docsGed = this.casamento.registro.documentosGED.filter(documento => {
              return ['PDF', 'PDFA'].indexOf(documento.tipo_documento) !== -1
            })
            this.casamento.registro.documentos =  this.casamento.registro.documentos.concat(docsGed)
          }

          if (this.propOS) {

          }

          if (this.propPedidoPendente) {
            this.pedidoPendente = this.propPedidoPendente
            this.tabIndex = 3

            if ((!this.propPedidoPendente.numPedidoPossueOrdemServico && !this.propPedidoPendente.numPedidoPossueCertidaoEletronica) || (!this.propPedidoPendente.numPedidoPossueOrdemServico && this.propPedidoPendente.numPedidoPossueCertidaoEletronica)) {
              this.newOs = true
            }

            if (this.propPedidoPendente.numPedidoPossueOrdemServico && !this.propPedidoPendente.numPedidoPossueCertidaoEletronica) {
              this.numeroPedidoPossueOrdemServico = true
              this.$nextTick(() => this.$bvModal.show('aviso-numero-pedido-possui-ordem-servico'))
            }

            if (this.propPedidoPendente.numPedidoPossueOrdemServico && this.propPedidoPendente.numPedidoPossueCertidaoEletronica) {
              this.tabIndex = 0
              this.numeroPedidoPossueCertidaoEletronica = true
              this.$nextTick(() => this.$bvModal.show('aviso-numero-pedido-possui-certidao-eletronica'))
            }
          }
        } catch (e) {
          console.error(e)
        } finally {
          loader({ active: false })
        }
      },
      async updateData () {
        this.casamento = await CasamentoService.getCasamento(this.$route.params.id)
      },
      updateOrdemServico (data, reset = false) {
        if (data) this.ordem_servico = [...data]
        else this.ordem_servico = []

        if (reset) {
          this.segundaVia = false
          this.novoProcedimento = false
        }
      },
      imprimir (os) {
        this.os = os
      },
      changeRegistro (registro, tabIndex = 0) {
        this.casamento = registro

        this.tabIndex = tabIndex

        this.newOs = false
      },
      acessarEHabilitacao () {
        if (!this.casamento.habilitacao || !this.casamento.habilitacao.habilitacao_casamento_id) return

        const url = `${window.location.origin}/habilitar-casamento/resumo/${this.casamento.habilitacao.habilitacao_casamento_id}`

        window.open(url)
      },
      goOS (registro) {
        this.segundaVia = true
        this.changeRegistro(registro, 3)

        this.ordemServicoCompare = [...this.ordem_servico]
      },
      tabImpressao () {
        this.tabIndex = 4
      },
      onFecharModal (status, resposta) {
        this.numeroPedidoPossueCertidaoEletronica = status
        this.respostaModalNumeroPedidoPossuiCertidaoEletronica = resposta

        if (resposta === 'Sim') {
          cumprirPedidos(this.propPedidoPendente)
        } else {
          this.tabIndex = 3
          this.numeroPedidoPossueOrdemServico = true
        }   
      }
    }
  }
</script>

<style  lang="scss" scoped>
  @import "./src/scss/_components/resumos";
  .headerBlueResumo{
    height: 215px;
  }
  .Resumo{
    & .nav-link.disabled {
      background-color: #dddddd !important;
    }
  }

  .registro {
    &_title {
      width: 19% !important;
    }

    &_dados {
      width: 80%;
    }
  }

  .btn-acessar-reg-hab {
    border: solid 1px #086aae;
    background-color: #ffffff;
    color: #074f7f;
  }

  .btn-acessar-reg-hab:hover {
    color: #074f7f;
    background-color: #ffffff;
  }

  .btn-acessar-reg-hab:disabled {
    color: #074f7f;
    background-color: #ffffff;
    opacity: 0.65;
  }
</style>
